import { Hero } from "../components/home/Hero";
import { Marquee } from "../components/site/Marquee";
import { Ingredients } from "../components/home/Ingredients";
import { FeaturedBars } from "../components/home/FeaturedBars";
import { MoreThanSnack } from "../components/home/MoreThanSnack";
import { StoryTeaser, SignupBlock } from "../components/home/StoryTeaser";

export default function Home() {
  return (
    <div data-testid="home-page">
      <Hero />
      <MoreThanSnack />
      <Marquee />
      <Ingredients />
      <FeaturedBars />
      <StoryTeaser />
      <SignupBlock />
    </div>
  );
}
